import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import FeaturedProducts from "./components/FeaturedProducts";
import SocialPreview from "./components/SocialPreview";
import InfluencerBanner from "./components/InfluencerBanner";
import InfluencerLeaderboard from "./components/InfluencerLeaderboard";
import CommissionBreakdown from "./components/CommissionBreakdown";
import InfluencerApplicationForm from "./components/InfluencerApplicationForm";
import HowItWorks from "./components/HowItWorks";
import NewArrivals from "./components/NewArrivals";
import BuyerRequirementsSection from "./components/BuyerRequirementsSection";
import GlobalFactoryMarketplace from "./components/GlobalFactoryMarketplace";
import StarBookPrimeSocial from "./components/StarBookPrimeSocial";
import InfantDonationSection from "./components/InfantDonationSection";
import RecruitmentSection from "./components/RecruitmentSection";
import { faqs } from "./components/FAQSection";
import SEO from "@/components/base/SEO";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const OG_IMAGE = "https://public.readdy.ai/ai/img_res/aa8053babb23069981d72b5a59fdf479.jpg";

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "StarBookPrime",
    "url": SITE_URL,
    "description": "USA verified factory marketplace for wholesale, bulk orders, dropshipping, and reseller commissions.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${SITE_URL}/marketplace?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "StarBookPrime",
    "url": SITE_URL,
    "logo": {
      "@type": "ImageObject",
      "url": `${SITE_URL}/favicon.png`,
    },
    "description": "StarBookPrime connects global buyers with verified USA factories for wholesale, bulk orders, and dropshipping. Earn commission as a reseller or influencer.",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer support",
      "availableLanguage": ["English", "Chinese"],
    },
    "sameAs": [],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.q,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.a,
      },
    })),
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen pb-16 lg:pb-0">
      <SEO
        title="StarBookPrime — USA Verified Factory Marketplace & Reseller Platform"
        description="Shop direct from verified USA factories. Wholesale bulk orders, dropshipping, and earn commission as a reseller or influencer. 500+ verified American manufacturers."
        keywords="USA factory marketplace, verified factory wholesale, reseller commission platform"
        canonical="/"
        ogImage={OG_IMAGE}
        schema={homeSchema}
      />
      <Navbar />
      <HeroSection />
      <NewArrivals />
      <InfantDonationSection />
      <HowItWorks />
      <GlobalFactoryMarketplace />
      <BuyerRequirementsSection />
      <RecruitmentSection />
      <FeaturedProducts />
      <StarBookPrimeSocial />
      <SocialPreview />
      <InfluencerBanner />
      <InfluencerLeaderboard />
      <CommissionBreakdown />
      <InfluencerApplicationForm />
      <Footer />
    </div>
  );
}
